import { ChatSender } from '../../types/chatSender';
import { SupportedChatChannel } from '../../chats/supportedChatChannel';
import { AppThunkAction } from '../index';
import { createChatChannelsAction } from './index';
import chatChannelProvider from '../../chats/chatChannelProvider';

const setSelectedChatSenderIdAction = createChatChannelsAction<{ senderId: string }>('senders/set')

export const setSelectedChatSenderId = (channel: SupportedChatChannel, senderId: string) => (
  setSelectedChatSenderIdAction(channel, { senderId })
);

const chatSendersFetchPendingAction = createChatChannelsAction('senders/fetchPending');
const chatSendersFetchSuccessAction = createChatChannelsAction<ChatSender[]>('senders/fetchSuccess');
const chatSendersFetchFailureAction = createChatChannelsAction<string>('senders/fetchFailure');

export const fetchChatSenders = (channel: SupportedChatChannel): AppThunkAction => {
  return async (dispatch, getState) => {
    const { customerUuid } = getState().login.userData;

    dispatch(chatSendersFetchPendingAction(channel));
    try {
      const chatSenders: ChatSender[] = await chatChannelProvider.get(channel)
        .api.fetchSenders(customerUuid);

      dispatch(chatSendersFetchSuccessAction(channel, chatSenders));
    } catch {
      dispatch(chatSendersFetchFailureAction(channel, 'Failed to fetch chat senders'));
    }
  };
};
